import axiosInstance from "./api";

const bookingApi = {
  getUserBookings: (userId, params = {}) =>
    axiosInstance.get(`/bookings/user/${userId}`, { params }),

  getOwnerBookings: (ownerId, params = {}) =>
    axiosInstance.get(`/bookings/owner/${ownerId}`, { params }),

  getBookingByProposalId: (proposalId) =>
    axiosInstance.get(`/bookings/proposal/${proposalId}`),

  getBookingByEventId: (eventId) =>
    axiosInstance.get(`/bookings/event/${eventId}`),

  getCartPreview: (payload) =>
    axiosInstance.post("/bookings/cart-preview", payload),

  applyPromoCode: (payload) =>
    axiosInstance.post("/bookings/apply-promo", payload),

  createBooking: (payload) =>
    axiosInstance.post("/bookings/create", payload),

  retryPayment: (payload) =>
    axiosInstance.post("/bookings/retry-payment", payload),

  payInstallment: (payload) =>
    axiosInstance.post("/bookings/pay-installment", payload),

  markProfessionalComplete: (bookingId) =>
    axiosInstance.put(`/bookings/${bookingId}/professional-complete`),

  markCustomerComplete: (bookingId, payload = {}) => {
    if (Array.isArray(bookingId)) {
      return axiosInstance.put("/bookings/customer-complete", {
        bookingIds: bookingId,
        ...payload,
      });
    }
    if (payload?.bookingIds) {
      return axiosInstance.put(`/bookings/${bookingId || "customer-complete"}/customer-complete`, payload);
    }
    return axiosInstance.put(`/bookings/${bookingId}/customer-complete`, payload);
  },

  cancelBooking: (bookingId, reason) =>
    axiosInstance.post(`/bookings/${bookingId}/cancel`, { reason }),

  getDisputeContext: (bookingId) =>
    axiosInstance.get(`/bookings/${bookingId}/dispute-context`),

  getDispute: (bookingId) =>
    axiosInstance.get(`/bookings/${bookingId}/dispute`),

  raiseDispute: (bookingId, data) =>
    axiosInstance.post(`/bookings/${bookingId}/dispute`, data),

  getPayoutInvoiceData: (bookingId) =>
    axiosInstance.get(`/bookings/${bookingId}/payout-invoice`),

  downloadPayoutInvoicePdf: (bookingId) =>
    axiosInstance.get(`/bookings/${bookingId}/payout-invoice/pdf`, {
      responseType: "blob",
    }),

  getCustomerStatementData: (eventId) =>
    axiosInstance.get(`/bookings/customer/event/${eventId}/statement`),

  downloadCustomerStatementPdf: (eventId) =>
    axiosInstance.get(`/bookings/customer/event/${eventId}/statement/pdf`, {
      responseType: "blob",
    }),

  getHostInvoiceData: (bookingId) =>
    axiosInstance.get(`/bookings/${bookingId}/host-invoice`),

  downloadHostInvoicePdf: (bookingId) =>
    axiosInstance.get(`/bookings/${bookingId}/host-invoice/pdf`, {
      responseType: "blob",
    }),
};



export default bookingApi;
